export default "__VITE_PUBLIC_ASSET__51b69dd0__"